module.exports = __webpack_public_path__ + "static/media/stofferingen-55.dec526b0.jpg";